export function getProcedures(procedures) {
  return procedures.map(procedure => ({
    id: procedure._id,
    text: procedure.insurance_code
      ? `${procedure.description} (${procedure.insurance_code.code})`
      : procedure.description,
  }))
}
